import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInsurancesRequest } from "../../../../../redux/inspection-firms/slice";
import { Card, Box, Typography, Divider } from "@mui/material";
import Loading from "../../../../../components/loading/loading";
import InsuranceDetailRow from "./InsuranceDetailRow";
import "./insurance.css";

type props = {
  data: any;
};

const Insurance = ({ data }: props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInsurancesRequest({ id: data?.id }));
  }, [data, dispatch]);

  const { loading, insurances } = useSelector(
    (state: any) => state.inspectionFirms
  );

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Insurance</Typography>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">General Liability*</Typography>
          <InsuranceDetailRow
            data={{
              ...(insurances?.filter(
                (item: any) => item.type === "GeneralLiability"
              )[0] || null),
              id: data?.id,
              type: "1",
              label: "General Liability",
            }}
          />
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Erros & Omissions* <br />
          </Typography>
          <InsuranceDetailRow
            data={{
              ...(insurances?.filter(
                (item: any) => item.type === "ErrorsAndOmissions"
              )[0] || null),
              id: data?.id,
              type: "2",
              label: "Errors & Omissions",
            }}
          />
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Worker's Compensation* <br />
          </Typography>
          <InsuranceDetailRow
            data={{
              ...(insurances?.filter(
                (item: any) => item.type === "WorkersCompensation"
              )[0] || null),
              id: data?.id,
              type: "3",
              label: "Worker's Compensation",
            }}
          />
        </Box>
      </Card>
      {loading && <Loading />}
    </>
  );
};

export default Insurance;
